<template>
  <div>
    <PageAllow controller="Economies" :action="isView ? 'view' : mode" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color py-4 mx-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{ $t("CRUD.info", [$t("Economies.ObjectName")]) }}
              <v-chip
                v-if="economy.cancel_flg"
                small
                label
                outlined
                class="ms-4 mt-1"
                color="danger"
              >
                {{ $t("CRUD.cancelled") }}
              </v-chip>
              <v-chip
                small
                label
                class="ms-4 mt-1"
                :color="economy.status | economyStatusColor"
                :text-color="economy.status | economyStatusTextColor"
              >
                {{ economy.status | economyStatusText }}
              </v-chip>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <!-- 保存编辑 -->
                <v-btn
                  v-if="
                    isComplete &&
                    $permission.permissionAllow('Economies', 'complete')
                  "
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="complete()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("Economies.actions.complete") }}
                </v-btn>
              </v-sheet>
              <EconomiesActions
                v-if="isView"
                :economy="economy"
                :showComplete="economy.actions && economy.actions.complete"
                :showCancel="economy.actions && economy.actions.account_cancel"
                class="ml-3"
              />
            </v-card-title>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Economies.Fields.economy_code") }}
                    {{ $t("Global.colon") }}
                  </span>
                  {{ economy.economy_code }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Economies.Fields.supplier_name") }}
                    {{ $t("Global.colon") }}
                  </span>
                  {{
                    economy && economy.supplier
                      ? economy.supplier.supplier_name
                      : ""
                  }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Economies.Fields.created_time") }}
                    {{ $t("Global.colon") }}
                  </span>
                  {{ economy.created | formatTime }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4" v-if="!isComplete">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Economies.DetailFields.confirm_user") }}
                    {{ $t("Global.colon") }}
                  </span>
                  {{
                    economy && economy.confirmer ? economy.confirmer.name : ""
                  }}
                </v-card>
              </v-col>
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("Economies.Fields.finished_time") }}
                    {{ $t("Global.colon") }}
                  </span>
                  {{ economy.complete_date | formatTime }}
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
          <v-expansion-panel v-if="isView">
            <v-expansion-panel-header class="py-0">
              <v-tabs v-model="tab" background-color="transparent">
                <v-tab
                  @click.stop="
                    tab = 0;
                    panels.find((p) => p == 1) ? null : panels.push(1);
                  "
                >
                  {{ $t("StockOrderIN.actions.activities") }}
                </v-tab>
              </v-tabs>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card flat>
                    <v-data-table
                      :headers="activitiesHeaders"
                      :items="activities_details"
                      class="elevation-0"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:item.created="{ item }">
                        <span class="text-no-wrap">
                          {{ item.created | formatTime }}
                        </span>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-data-table
        id="economy_details_table"
        :headers="detailsHeaders"
        :items="economyDetailItems"
        :search="filter"
        disable-sort
        class="elevation-2 px-4 mt-4"
        disable-pagination
        hide-default-footer
        :no-data-text="$t('Order.DetailNoData')"
      >
        <template v-slot:top>
          <v-toolbar flat class="transparent-background-color">
            <v-toolbar-title class="ms-n2">
              {{ $t("CRUD.details", [$t("Economies.ObjectName")]) }}
            </v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-toolbar
            flat
            class="transparent-background-color"
            align-self="center"
          >
            <v-row no-gutters class="me-n3">
              <span class="caption secondary--text pt-2">
                {{
                  $t(
                    "$vuetify.dataFooter.pageText",
                    economy_details
                      ? [
                          economy_details.length > 0 ? 1 : 0,
                          economy_details.length,
                          economy_details.length,
                        ]
                      : [0, 0, 0]
                  )
                }}
              </span>
              <v-row no-gutters>
                <v-spacer />
                <v-col cols="12" sm="9" md="8">
                  <v-text-field
                    v-model="filter"
                    clearable
                    hide-details
                    :label="$t('Search.filter')"
                  />
                </v-col>
              </v-row>
            </v-row>
          </v-toolbar>
        </template>

        <template v-slot:item.last_supplier_price="{ item }">
          {{ $t("Global.money") }}{{ item.last_supplier_price | formatMoney }}
        </template>
        <template v-slot:item.current_supply_price="{ item }">
          <a
            @click.stop="
              currentDetail = item;
              lineChartMaterialName = item.Description;
              echartsDialog = true;
            "
          >
            {{ $t("Global.money") }}
            {{ item.current_supply_price | formatMoney }}
          </a>
        </template>
        <template v-slot:item.quotation_supply_price="{ item }">
          <span v-if="isView">
            {{ $t("Global.money") }}
            {{ item.quotation_supply_price | formatMoney }}
          </span>
          <v-text-field
            v-else
            v-model="item.quotation_supply_price"
            single-line
            dense
            hide-details
            type="number"
            min="0"
            :prefix="$t('Global.money')"
            disabled
            style="max-width: 80px; margin-left: auto"
          />
        </template>
        <template v-slot:item.supply_price="{ item }">
          <span v-if="isView">
            <span v-if="item.supply_price != ''">
              {{ $t("Global.money") }}{{ item.supply_price | formatMoney }}
            </span>
          </span>
          <v-text-field
            v-else
            v-model="item.supply_price"
            single-line
            dense
            hide-details
            type="number"
            min="0"
            :prefix="$t('Global.money')"
            disabled
            style="max-width: 80px; margin-left: auto"
          />
        </template>
      </v-data-table>
    </v-sheet>

    <CompleteResultDialog
      v-model="errorDialog"
      :errorEconomies="errorData"
      :economy="economy"
    />

    <DialogEconomyHistoryEcharts
      v-model="echartsDialog"
      :supplierId="economy.supplier_id"
      :currentDetail="currentDetail"
      :lineChartMaterialName="lineChartMaterialName"
      @close="echartsDialog = false"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import EconomiesActions from "./plugins/Actions";
import Economies from "@/api/economies";
import CompleteResultDialog from "./plugins/CompleteResultDialog";
import DialogEconomyHistoryEcharts from "@/components/plugins/DialogEconomyHistoryEcharts";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    EconomiesActions,
    CompleteResultDialog,
    DialogEconomyHistoryEcharts,
  },
  computed: {
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.purchases"),
          disabled: false,
          href: "/purchases",
        },
        {
          text: i18n.t("Nav.economy"),
          href: "/economies",
          disabled: false,
        },
        {
          text: this.isComplete
            ? i18n.t("Nav.economyComplete")
            : i18n.t("Nav.economyDetail"),
          disabled: true,
        },
      ];
      if (this.economy && this.economy.economy_code) {
        items.push({
          text: this.economy.economy_code,
          disabled: false,
          accent: true,
        });
      }
      return items;
    },
    isView() {
      return !this.mode;
    },
    isComplete() {
      return this.mode == "complete";
    },

    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("Economies.DetailFields.material_category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("Economies.DetailFields.material_name"),
          align: "start",
          value: "Description",
        },
        {
          text: i18n.t("Economies.DetailFields.unit"),
          align: "center",
          value: "unit",
        },
        {
          text: i18n.t("Economies.DetailFields.last_supply_price"),
          align: "end",
          value: "last_supplier_price",
        },
        {
          text: i18n.t("Economies.DetailFields.current_supply_price"),
          align: "end",
          value: "current_supply_price",
        },
        {
          text: i18n.t("Economies.DetailFields.supplier_quote_price"),
          align: "end",
          value: "quotation_supply_price",
        },
        {
          text: i18n.t("Economies.DetailFields.economy_price"),
          align: "center",
          value: "supply_price",
        },
      ];

      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }

      return headers;
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("Economies.ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("Economies.ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("Economies.ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],

    economyDetailItems() {
      return this.economy_details.map((detail) => {
        detail.Description = i18n.t(
          this.settings
            ? this.settings.material_name_display_type == 4
              ? "Material.nameWithCodeAndStandard"
              : this.settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
              : this.settings.material_name_display_type == 2
              ? "Material.materialNameWithCode"
              : "Material.materialName"
            : "Material.materialName",
          [detail.material_code, detail.material_name, detail.standard_name]
        );
        return detail;
      });
    },

    ...mapState(["settings", "accountUser", "accountInfo"]),
  },

  data: () => ({
    tab: null,
    panels: [0],
    mode: "",
    economy: {},
    activities_details: [],
    economy_details: [],
    filter: "",
    errorDialog: false,
    errorData: [],
    echartsDialog: false,
    currentDetail: null,
    lineChartMaterialName: "",
  }),

  mounted() {
    this.mode = this.$route.params.mode;
    if (this.mode) this.$router.replace("/economies/" + this.$route.params.id);
  },

  methods: {
    getEconomyFromAPI() {
      Economies.fetchOne(this.$route.params.id, { order_activity: 1 }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.economy = response.data.economy;
            this.economy_details = response.data.economy.economy_details;
            this.activities_details = response.data.order_activities;
          }
        }.bind(this)
      );
    },
    submitMethod(action) {
      if (action == "complete")
        return Economies.complete(this.economy.id, this.economy);
      else if (action == "question")
        return Economies.question(this.economy.id, this.economy);
    },
    complete() {
      Economies.complete(this.economy.id, this.economy).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$router.push("/economies");
          } else if (
                  response.data.error &&
                  response.data.error.code &&
                  response.data.error.code == "ERR668"
          ) {
            this.errorData = response.data.errorData;
            this.errorDialog = true;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    $route(to) {
      if (to.params.mode) {
        this.mode = to.params.mode;
        this.$router.replace("/economies/" + this.$route.params.id);
      }
    },
    mode: {
      handler() {
        if (this.$route.params.id) {
          this.getEconomyFromAPI();
        }
      },
    },
  },
};
</script>